import { render, staticRenderFns } from "./SAMPLE_RECOLLECT.vue?vue&type=template&id=506141ea"
import script from "./SAMPLE_RECOLLECT.vue?vue&type=script&lang=js"
export * from "./SAMPLE_RECOLLECT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports